import { THEME } from "../../enums";
import {
  audioPlayerLightThemeVolumeBarBackgroundColor,
  audioPreviewButtonDisabledDarkThemeBackgroundColor,
  audioPreviewButtonDisabledDarkThemeColor,
  audioPreviewButtonDisabledLightThemeBackgroundColor,
  audioPreviewButtonDisabledLightThemeColor,
  darkThemeBackgroundInteractive,
  darkThemeBufferBackgroundColor,
  darkThemeColor,
  darkThemeHoverColor,
  darkThemeProgressBarBackgroundColor,
  darkThemeShareLinkHoverBackgroundColor,
  darkThemeTextColor,
  lightThemeBackgroundInteractive,
  lightThemeBufferBackgroundColor,
  lightThemeColor,
  lightThemeHoverColor,
  lightThemeProgressBarBackgroundColor,
  lightThemeProgressBarElapsedColor,
  lightThemeShareLinkHoverBackgroundColor,
  lightThemeTextColor,
  progressBarElapsedColor
} from "../../styles/variables";
import { Theme } from "../../types/common";

export type ThemeColors = {
  backgroundInteractive: string;
  baseColor: string;
  bufferBackgroundColor: string;
  defaultTextColor: string;
  disabledBackgroundColor: string;
  disabledColor: string;
  fillColor: string;
  hoverColor: string;
  progressBarBackgroundColor: string;
  progressBarElapsedColor: string;
  shareLinkHoverBackgroundColor: string;
  volumeBarBackgroundColor: string;
  volumeLevelColor: string;
};

const getThemeColors = (theme: Theme): ThemeColors => {
  const themeIsAutoAndUserPrefersDark =
    theme === THEME.AUTO &&
    window.matchMedia("(prefers-color-scheme: dark)").matches;
  const embeddedOnDarkBackground =
    theme === THEME.DARK || themeIsAutoAndUserPrefersDark;

  if (embeddedOnDarkBackground) {
    return {
      backgroundInteractive: darkThemeBackgroundInteractive,
      baseColor: darkThemeColor,
      bufferBackgroundColor: darkThemeBufferBackgroundColor,
      defaultTextColor: darkThemeTextColor,
      disabledBackgroundColor:
        audioPreviewButtonDisabledDarkThemeBackgroundColor,
      disabledColor: audioPreviewButtonDisabledDarkThemeColor,
      fillColor: lightThemeColor,
      hoverColor: darkThemeHoverColor,
      progressBarBackgroundColor: darkThemeProgressBarBackgroundColor,
      progressBarElapsedColor: progressBarElapsedColor,
      shareLinkHoverBackgroundColor: darkThemeShareLinkHoverBackgroundColor,
      volumeBarBackgroundColor: darkThemeProgressBarBackgroundColor,
      volumeLevelColor: progressBarElapsedColor
    };
  } else {
    return {
      backgroundInteractive: lightThemeBackgroundInteractive,
      baseColor: lightThemeColor,
      bufferBackgroundColor: lightThemeBufferBackgroundColor,
      defaultTextColor: lightThemeTextColor,
      disabledBackgroundColor:
        audioPreviewButtonDisabledLightThemeBackgroundColor,
      disabledColor: audioPreviewButtonDisabledLightThemeColor,
      fillColor: darkThemeColor,
      hoverColor: lightThemeHoverColor,
      progressBarBackgroundColor: lightThemeProgressBarBackgroundColor,
      progressBarElapsedColor: lightThemeProgressBarElapsedColor,
      shareLinkHoverBackgroundColor: lightThemeShareLinkHoverBackgroundColor,
      volumeBarBackgroundColor: audioPlayerLightThemeVolumeBarBackgroundColor,
      volumeLevelColor: darkThemeColor
    };
  }
};

export default getThemeColors;
